import { config } from "../../config";
import { store } from "../store";

/**
 * Web port of the RN `cloudinaryUploadPdf` middleware.
 *
 * RN builds the PDF natively with `react-native-html-to-pdf` and posts the
 * finished bytes as a `pdfBase64` data URI. The web build has no native PDF
 * engine, so it posts the finished agreement HTML instead and the API renders it
 * with the puppeteer install it already carries. Either way the stored
 * `signed_agreement` value is the same thing: a Cloudinary PDF URL, which is what
 * every viewer of that column already expects.
 *
 * @param html the finalized, self-contained agreement document
 * @param publicId Cloudinary public_id, `quoteNumber-HHMMSS`
 * @returns the Cloudinary secure_url, or `undefined` when the upload failed
 */
export const uploadAgreementPdf = async (
  html: string,
  publicId: string,
): Promise<string | undefined> => {
  if (!html) return undefined;

  const appKey = store.getState().auth.app_key;
  const accessToken = store.getState().auth.access_token;

  try {
    const response = await fetch(`${config.API_URL}/api/sponsor/uploadAgreementPdf`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: config.API_KEY,
        appkey: appKey || config.APP_KEY,
        accesstoken: accessToken || "",
      },
      body: JSON.stringify({ html, publicId }),
    });
    const result = await response.json();
    if (result.status === 1 && result.resp) {
      return result.resp;
    }
    console.error(`uploadAgreementPdf rejected: ${JSON.stringify(result)}`);
    return undefined;
  } catch (err) {
    console.error(`uploadAgreementPdf ${err}`);
    return undefined;
  }
};
